import { FC } from "react";
import { Drawer } from "@mantine/core";

import SearchMenu from "../SearchMenu";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSearch: (searchTerm: string) => void;
};

const SearchModal: FC<Props> = ({
  isOpen,
  onClose,
  onSearch,
}) => {
  return (
    <Drawer
      opened={isOpen}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => {
        onClose();
      }}
      position="bottom"
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <SearchMenu
        onSearch={onSearch}
        onClose={onClose}
      />
    </Drawer>
  );
};

export default SearchModal;
